import PortfolioCoinTransactionController from "./portfolio_coin_transactions_controller";
import { EventToast } from "../events";
import { getCSRFToken } from "../util";

export default class extends PortfolioCoinTransactionController {
  static targets = [];

  connect() {}

  deleteTransaction(event) {
    const transactionId = event.currentTarget.dataset.transactionId,
      deletePath = event.currentTarget.dataset.deletePath;

    fetch(`${deletePath}/${transactionId}`,
      {
        credentials: "same-origin",
        method: "DELETE",
        headers: {
          "X-CSRF-Token": getCSRFToken()
        }
      })
      .then(res => res.json())
      .then(data => {
        if (data.message == "success") {
          window.dispatchEvent(
            new CustomEvent(EventToast, {
              detail: {
                notice: "Successful"
              }
            })
          )
          window.location.reload();
        } else {
          throw new Error("Failed to delete");
        }
      })
      .catch(error => {
        window.dispatchEvent(
          new CustomEvent(EventToast, {
            detail: {
              notice: "Unsuccessful"
            }
          })
        )
      });
  }
}
